import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const rateIdSelectorAtom = atom<string | null>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);

  return bookingWizardData?.type === "GolfBooking"
    ? bookingWizardData.rateId
    : null;
});
